/* eslint-disable no-undef */
import { all, takeLatest, put, take } from 'redux-saga/effects';

import { Actions as SnackbarActions, Types as SnackbarTypes } from '../sagas/snackbar';
import { Actions as UserActions, Types as UserTypes } from '../sagas/users';

function* watchSuccessSelfData() {
  while (true) {
    yield take(UserTypes.successSelfData);
  }
}

function* watchSuccessLogout() {
  while(true) {
    yield take(UserTypes.successLogout);

    yield put({ type: UserTypes.failedAuthentication });
  }
}

export default function* root() {
  yield all([
    takeLatest(SnackbarTypes.close, SnackbarActions.requestClose),
    takeLatest(SnackbarTypes.show, SnackbarActions.requestShow),
    takeLatest(UserTypes.authenticate, UserActions.requestAuthenticate),
    takeLatest(UserTypes.changePassword, UserActions.requestChangePassword),
    takeLatest(UserTypes.logout, UserActions.requestLogout),
    takeLatest(UserTypes.selfData, UserActions.requestSelfData),
    takeLatest(UserTypes.selfCreate, UserActions.requestSelfCreate),
    takeLatest(UserTypes.recoverPassword, UserActions.requestRecoverPassword),
    takeLatest(UserTypes.resendActivateCode, UserActions.requestResendActivateCode),
    takeLatest(UserTypes.validateActivateCode, UserActions.requestValidateActivateCode),
    takeLatest(UserTypes.updateProfile, UserActions.requestUpdateProfile),
    takeLatest(UserTypes.requestSelectCompany, UserActions.requestSelectCompany),
    takeLatest(UserTypes.requestSelectRegional, UserActions.requestSelectRegional),
    takeLatest(UserTypes.requestSelectOffice, UserActions.requestSelectOffice),
    takeLatest(UserTypes.requestGetCompanies, UserActions.requestGetCompanies),
    takeLatest(UserTypes.requestGetRegionals, UserActions.requestGetRegionals),
    takeLatest(UserTypes.requestGetOffices, UserActions.requestGetOffices),
    watchSuccessSelfData(),
    watchSuccessLogout(),
  ]);
}
